import { FadeUp } from "@/components/AnimatedSection";
import { Instagram, ArrowRight, Heart, Camera } from "lucide-react";
import { motion } from "framer-motion";

const InstagramFeed = () => (
  <section className="section-padding bg-background relative overflow-hidden">
    <div className="orb-glow orb-gold w-[400px] h-[400px] bottom-0 right-0 opacity-8 orb-pulse" />
    <div className="absolute inset-0 mesh-gradient" />
    <div className="container-luxury relative">
      <FadeUp className="text-center mb-14">
        <span className="badge-shimmer mb-4 inline-flex">Follow Our Work</span>
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
          <span className="gold-gradient-text-animated">@themetroshine</span>
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto text-sm leading-relaxed">
          See our latest transformations and behind-the-scenes content on Instagram.
        </p>
      </FadeUp>

      <FadeUp>
        <motion.a
          href="https://www.instagram.com/themetroshine/"
          target="_blank"
          rel="noopener noreferrer"
          className="block luxury-card-elite p-10 md:p-16 text-center group cursor-pointer rounded-2xl relative overflow-hidden"
          whileHover={{ y: -8, transition: { duration: 0.4 } }}
        >
          <div className="absolute inset-0 mesh-gradient" />
          <div className="absolute inset-0 bg-diagonal opacity-15" />
          <div className="relative">
            {/* Decorative icons */}
            <div className="absolute top-0 left-1/4 opacity-0 group-hover:opacity-20 transition-opacity duration-700">
              <Heart size={20} className="text-primary animate-float" />
            </div>
            <div className="absolute top-4 right-1/3 opacity-0 group-hover:opacity-15 transition-opacity duration-700 delay-200">
              <Camera size={16} className="text-primary animate-float-slow" />
            </div>

            <motion.div
              className="w-20 h-20 rounded-2xl gold-gradient-bg flex items-center justify-center mx-auto mb-8 gold-glow-strong shadow-xl shadow-primary/20"
              whileHover={{ scale: 1.15, rotate: 10 }}
            >
              <Instagram size={36} className="text-primary-foreground" />
            </motion.div>
            <h3 className="font-display text-2xl md:text-3xl font-bold mb-3 group-hover:text-primary transition-colors">@themetroshine</h3>
            <p className="text-muted-foreground text-sm mb-10 max-w-md mx-auto leading-relaxed">
              Follow us for daily detailing content, transformations, tips, and exclusive behind-the-scenes looks at our process.
            </p>
            <motion.span
              className="inline-flex items-center gap-2 gold-gradient-bg text-primary-foreground px-8 py-3.5 rounded-xl text-sm font-semibold tracking-wider btn-luxury btn-shine btn-magnetic"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              Follow on Instagram <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </motion.span>
          </div>
        </motion.a>
      </FadeUp>
    </div>
  </section>
);

export default InstagramFeed;
